// Generated by scripts/stats/update_language_stats.js@inventaire-i18n
export default {
  ar: {
    completion: 56,
    defaultRegion: 'ar_AR'
  },
  bn: {
    completion: 69,
    defaultRegion: 'bn_BN'
  },
  ca: {
    completion: 97,
    defaultRegion: 'ca_CA'
  },
  cs: {
    completion: 42,
    defaultRegion: 'cs_CS'
  },
  da: {
    completion: 48,
    defaultRegion: 'da_DK'
  },
  de: {
    completion: 97,
    defaultRegion: 'de_DE'
  },
  el: {
    completion: 6,
    defaultRegion: 'el_EL'
  },
  en: {
    completion: 100,
    defaultRegion: 'en_US'
  },
  eo: {
    completion: 16,
    defaultRegion: 'eo_EO'
  },
  es: {
    completion: 96,
    defaultRegion: 'es_ES'
  },
  fi: {
    completion: 7,
    defaultRegion: 'fi_FI'
  },
  fr: {
    completion: 100,
    defaultRegion: 'fr_FR'
  },
  hu: {
    completion: 12,
    defaultRegion: 'hu_HU'
  },
  id: {
    completion: 60,
    defaultRegion: 'id_ID'
  },
  it: {
    completion: 79,
    defaultRegion: 'it_IT'
  },
  ja: {
    completion: 45,
    defaultRegion: 'ja_JP'
  },
  nb: {
    completion: 10,
    defaultRegion: 'nb_NB'
  },
  nl: {
    completion: 55,
    defaultRegion: 'nl_NL'
  },
  pa: {
    completion: 7,
    defaultRegion: 'pa_PA'
  },
  pl: {
    completion: 52,
    defaultRegion: 'pl_PL'
  },
  pt: {
    completion: 42,
    defaultRegion: 'pt_PT'
  },
  ro: {
    completion: 86,
    defaultRegion: 'ro_RO'
  },
  ru: {
    completion: 63,
    defaultRegion: 'ru_RU'
  },
  sk: {
    completion: 24,
    defaultRegion: 'sk_SK'
  },
  sv: {
    completion: 96,
    defaultRegion: 'sv_SE'
  },
  th: {
    completion: 4,
    defaultRegion: 'th_TH'
  },
  tr: {
    completion: 46,
    defaultRegion: 'tr_TR'
  },
  uk: {
    completion: 66,
    defaultRegion: 'uk_UK'
  }
} as const